import { useCallback } from "react";
import { useLocation } from "react-router-dom";
import { PAGE_HASH } from "../../../../atoms/location/locationAtom";
import useHashBoolean from "../../../../hooks/reactRouterHooks/useHashBoolean";

export const useShowEditReleaseTrackSidePanel = () => {
  const location = useLocation();
  const { isOpen, closeHash, openHash } = useHashBoolean({
    value: PAGE_HASH.EDIT_RELEASE_TRACK,
  });

  const updateUrlWithReleaseTrackId = useCallback(
    (releaseTrackId?: number) => {
      const params = new URLSearchParams(location.search);
      if (releaseTrackId) {
        params.set("release_track_id", releaseTrackId.toString());
      } else {
        params.delete("release_track_id");
      }
      return params.toString();
    },
    [location.search],
  );

  return useCallback(
    (releaseTrackId: number) => {
      if (isOpen) {
        closeHash(updateUrlWithReleaseTrackId());
      } else {
        openHash(updateUrlWithReleaseTrackId(releaseTrackId));
      }
    },
    [isOpen, closeHash, openHash, updateUrlWithReleaseTrackId],
  );
};
